module.exports = __webpack_public_path__ + "public/images/prizes/prize-1.67ffa032dc3135c2a3fa2ff22165dc6b.jpeg";